import React from "react"
import { 
  FacebookShareButton,
  TwitterShareButton,
  LineShareButton,
  LineIcon
} from 'react-share'
import * as styles from "../../styles/components/share-button.module.scss"

export default function ShareButtons(props) {
  return (
    <ul className={props.style}>
      <li>
        <FacebookShareButton url={props.url}>
          <div className={`${styles.shareButton} ${styles.facebook}`}><img src="/images/facebook-logo.svg" width="16" height="16" alt="facebook" />Share</div>
        </FacebookShareButton>
      </li>
      <li>
        <TwitterShareButton url={props.url}>
          <div className={`${styles.shareButton} ${styles.x}`}><img src="/images/x-logo.svg" width="16" height="16" alt="x" />Post</div>
        </TwitterShareButton>
      </li>
      <li>
        <LineShareButton url={props.url}>
          <div className={`${styles.shareButton} ${styles.line}`}><LineIcon round={true} />Share</div>
        </LineShareButton>
      </li>
      <li>
        <a className={styles.shareLink} href={`https://note.com/intent/post?url=${props.url}`} target="_blank" rel="noreferrer noopener">
          <div className={`${styles.shareButton} ${styles.note}`}><img src="/images/note-logo.svg" width="16" alt="note" />note</div>
        </a>
      </li>
    </ul>
  )
}

